<template>
  <div class="market_page">
    <div class="market">
      <div class="left_box">
        <Tabs v-model="tabLevelOne" name="tab1_main" :animated="false" class="tabLevelOne">
          <TabPane :label="$t('主板区')" name="main" tab="tab1_main">
            <Tabs name="tab2_main" v-model="tabLevelTwo" :animated="false" class="tabLevelTwo">
              <TabPane :label="key" :name="key" v-for="(value, key, index) in coinListObj" :key="index" tab="tab2_main">
                <CoinList :loading="loading" :isSelf="false" :coinList="value"></CoinList>
              </TabPane>
            </Tabs>
          </TabPane>
          <TabPane :label="$t('自选')" name="collection" tab="tab1_main">
            <CoinList v-if="collectionList.length > 0" :loading="loading" :isSelf="true" :coinList="collectionList"></CoinList>
            <NoData v-else height="300px" sceneType="day"></NoData>
          </TabPane>
        </Tabs>
      </div>
      <div class="right_box">
        <CoinIntroduction></CoinIntroduction>
      </div>
    </div>
  </div>
</template>
<script>
import CoinList from '@/views/market/components/CoinList'
import CoinIntroduction from '@/views/market/components/CoinIntroduction'
import collect from '@/mixin/collect'
import { sendWSPush } from '@/utils/webSocket'
import { SET_CURRENT_COIN_INFO } from '@/store/mutation-types'
import { mapState } from 'vuex'
export default {
  components: {
    CoinList,
    CoinIntroduction
  },
  mixins: [collect],
  data () {
    return {
      loading: false,
      tabLevelOne: 'main',
      tabLevelTwo: 'USDT',
      coinListObj: {
        USDT: []
      },
      collectionList: [] // 保存自选数据
    }
  },
  computed: {
    isSign () {
      return this.$store.state.token
    },
    ...mapState(['coinData'])
  },
  watch: {
    coinData (newData, oldData) {
      this.loading = false
      const saveData = JSON.parse(JSON.stringify(newData.data))
      delete saveData.all
      this.coinListObj = saveData
      if (this.isSign) {
        this.collectionList = this.dealOriginCoinCollectList(newData.data.all)
      } else {
        this.collectionList = this.dealLocalCoinCollectList(newData.data.all)
      }
      
      // 将当前选中币种或者默认币种的最新数据推送
      for (const obj of newData.data.all) {
        if (this.$store.state.market.currentCoinName === obj.symbol) {
          this.$store.commit(`market/${SET_CURRENT_COIN_INFO}`, obj)
        }
      }
    }
  },
  created () {
    this.loading = true
    // 先获取用户收藏币种列表再获取市场币种数据
    // this.$store.dispatch('market/setCollectionCoin').then(() => {
    //   sendWSPush({ action: 'coin' })
    // })
  } 
}
</script>
<style lang="less" scoped>
.market_page{
  padding: 20px 20px 0;
  background:rgba(19,22,37,1);
  .market{
    height: 840px;
    display: flex;
    flex-direction: row;
    .left_box{
      margin-right: 20px;
      flex-grow: 1;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background:rgba(255,255,255,1);
    }
  }
}
</style>
